import { motion } from "framer-motion";
import styles from "./style.module.scss";
import MainSharedComponent from "./sharedMainComponent";
import ExpertsMultipleMarketsIcon from "./icons/expertsMultipleMarketsIcon";
import SpeakSeveralLanguagesIcon from "./icons/speakSeveralLanguagesIcon";
import CollaborationIcon from "./icons/collaborationIcon";
import FlexibilityIcon from "./icons/flexibilityIcon";
import SeveralDigitalMarketingIcon from "./icons/severalDigitalMarketingIcon";
import AccountBasedMarketingIcon from "./icons/accountBasedMarketingIcon";
import PerformanceBasedPricingModelIcon from "./icons/performanceBasedPricingModelIcon";
import DedicatedAccountManagerIcon from "./icons/dedicatedAccountManagerIcon";
import CuttingEdgeTechnologyIcon from "./icons/cuttingEdgeTechnologyIcon";
import FiltersQualifyLeadsIcon from "./icons/filtersQualifyLeadsIcon";
import PrivacySecurityIcon from "./icons/privacySecurityIcon";
import SpecialistsEachCategoryIcon from "./icons/specialistsEachCategoryIcon";
import SpecializeInSEMIcon from "./icons/specializeInSemIcon";

const list = [
    {
        title: "We're Experts in Multiple Markets",
        p: "We work across legal, B2B, auto, home services, and consumer technology, with additional experience in financial products and other B2C categories. Our vertical specialists tailor each campaign to the dynamics of that specific market.",
        icon: <ExpertsMultipleMarketsIcon />,
    },
    {
        title: "We Speak Several Languages",
        p: "We build campaigns with translated landing pages and geo-targeted messaging, not just translated ad copy, so language differences don't stand between you and the audience you're trying to reach.",
        icon: <SpeakSeveralLanguagesIcon />,
    },
    {
        title: "Collaboration",
        p: "We stay in regular contact with the businesses we work with, keeping you updated on campaigns, answering questions, and solving problems together.",
        icon: <CollaborationIcon />,
    },
    {
        title: "Flexibility",
        p: "Our agreements allow cancellation with just 48 hours' notice, no long-term lock-in required. We tailor the pricing model to what makes sense for your goals, rather than forcing every partner into the same structure.",
        icon: <FlexibilityIcon />,
    },
    {
        title: "Account-Based Marketing (ABM)",
        p: "We focus on real, ideal-fit customers, not vague personas, using tools like hyper-personalized LinkedIn outreach and IP-based targeting rather than broad contact lists. Thorough research helps us reach people actively seeking our partners' products or services, which means better-fit leads, not just more of them.",
        icon: <AccountBasedMarketingIcon />,
    },
    {
        title: "Performance-Based Pricing Model",
        p: "We offer performance-based pricing, including cost-per-lead, cost-per-call, and cost-per-click, plus other models tailored to your goals. You only pay when we deliver against agreed milestones, which keeps our incentives aligned with yours.",
        icon: <PerformanceBasedPricingModelIcon />,
    },
    {
        title: "Dedicated Account Manager",
        p: "Each partner gets a dedicated account manager as their main point of contact, with biweekly check-ins covering campaign progress, performance data, and any adjustments needed to stay aligned with your goals.",
        icon: <DedicatedAccountManagerIcon />,
    },
    {
        title: "Cutting-Edge Technology",
        p: "Whether you're looking to generate more leads or improve existing campaigns, our machine-learning-powered technology helps identify patterns and optimize campaigns efficiently, supporting sustainable growth over time.",
        icon: <CuttingEdgeTechnologyIcon />,
    },
    {
        title: "Lead Verification Filters",
        p: "Every lead goes through automated checks and human review: filtering fraudulent submissions, running syntax checks, matching phone numbers to names and addresses, flagging duplicates, and checking for suspicious IP addresses. Anything that doesn't clear these checks gets held for review before it reaches you.",
        icon: <FiltersQualifyLeadsIcon />,
    },
    {
        title: "Several Digital Marketing Tools",
        p: "We work across a range of channels, social media, search engines like Google, Bing, and Yahoo, dedicated landing pages, and review and comparison sites, choosing the mix that fits where your audience actually is.",
        icon: <SeveralDigitalMarketingIcon />,
    },
    {
        title: "Privacy & Security",
        htmlP: (
            <>
                We comply with TCPA and CCPA/CPRA regulations, and every lead
                comes with TrustedForm and Jornaya ID verification. You can
                review the full details in our{" "}
                <a
                    href="https://severalbrands.com/privacy-policy"
                    className="text-[#EF4F80] hover:underline"
                >
                    Privacy Policy
                </a>
                .
            </>
        ),
        icon: <PrivacySecurityIcon />,
    },
    {
        title: "Specialists in Each Category",
        p: "Behind every campaign is a team with real depth, engineers, marketers, social media specialists, and content writers who understand their categories in detail. That range of expertise is how we target the right audience effectively and translate that into leads that convert.",
        icon: <SpecialistsEachCategoryIcon />,
    },
    {
        title: "We Specialize in SEM",
        p: "With over 100 landing pages, we know how to target the right audience with the right keywords, driving traffic that converts into real business for our partners. We rank well across both organic and paid search.",
        icon: <SpecializeInSEMIcon />,
    },
];

export default function SecondSection() {
    return (
        <section
            className={`${styles["bgStyle"]} px-4 lg:px-0 mt-10 lg:mt-0  `}
        >
            <div className="py-20 lg:py-52">
                <motion.div
                    transition={{ duration: 1.5 }}
                    initial={{ opacity: 0, y: 150 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                >
                    <h2 className="font-bold text-[#37367D] 3xl:text-7xl 3xl:leading-[4.5rem] lg:text-5xl lg:leading-[3.5rem] text-3xl leading-10 ">
                        Values in Action
                    </h2>
                    <h3 className="text-[#EF4F80] 3xl:text-3xl 3xl:leading-[3.5rem] lg:text-xl text-lg lg:leading-10 3xl:mt-3 mt-1">
                        Where Ideas Meet Execution
                    </h3>
                    <p className="mt-5 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1027px] lg:max-w-[827px] font-light">
                        From search visibility to lead verification and
                        everything in between, here's a closer look at how our
                        values show up in the way we actually work.
                    </p>
                </motion.div>
                <ul
                    className={`flex  flex-wrap  mt-16 3xl:gap-[160px] lg:gap-[110px] gap-[60px]`}
                >
                    {list.map((el, index) => (
                        <MainSharedComponent
                            key={index}
                            title={el.title}
                            description={el.p}
                            htmlDescription={el.htmlP}
                            icon={el.icon}
                        />
                    ))}
                </ul>
            </div>
        </section>
    );
}
